module.exports = __webpack_public_path__ + "media/entities/1202-df055016.png";